export default __webpack_public_path__ + "static/06-6992e444a576c9681b6548987f83d726.jpg";